export default __webpack_public_path__ + "static/media/bg_main_ip.aeae14fb5048ee5c73fa573e379ca0b0.svg";